/**
 * Category utility functions
 */

/**
 * Determines if a category is a section based on its path parts
 *
 * Sections are intermediate levels in the category hierarchy:
 * - With ROOT: sections have ODD length path (e.g., ['ROOT', 'sectionId'])
 * - Without ROOT: sections have EVEN length path (e.g., ['sectionId'])
 *
 * @param {Array} pathParts - Array of path components
 * @returns {boolean} - True if the category is a section
 *
 * @example
 * isSection(['ROOT', 'section1']) // true - section with root
 * isSection(['ROOT', 'section1', 'directory1']) // false - directory
 * isSection(['section1']) // true - section without root
 * isSection(['section1', 'folder']) // false - directory without root
 */
export const isSection = (pathParts = []) => {
  const hasRoot = pathParts?.includes(new RegExp(/ROOT/gi));
  return hasRoot ? pathParts?.length % 2 !== 0 : pathParts?.length % 2 === 0;
};
